import { MultiSelect, SectionHeader } from "./CreateJobFields"

type CertificationRequirementsSectionProps = {
    certificates: Array<{ id: number; name: string }>
    certificatesStatus: string
    certificationIds: number[]
    customCertificationNames: string[]
    otherCertificationOption: string
    isEditMode: boolean
    onToggle: (value: string) => void
}

export const CertificationRequirementsSection = ({
    certificates,
    certificatesStatus,
    certificationIds,
    customCertificationNames,
    otherCertificationOption,
    isEditMode,
    onToggle,
}: CertificationRequirementsSectionProps) => (
    <section className="mb-10">
        <SectionHeader title="Certification requirements" />
        <div className="mb-4">
            <MultiSelect
                options={[...certificates.map((certificate) => certificate.name), otherCertificationOption]}
                selected={[
                    ...certificationIds
                        .map((id) => certificates.find((certificate) => certificate.id === id)?.name || "")
                        .filter(Boolean),
                    ...customCertificationNames,
                ]}
                onToggle={(value) => {
                    if (!isEditMode) {
                        onToggle(value)
                    }
                }}
                placeholder={certificatesStatus === "loading" ? "Loading..." : "Select certificates"}
            />
        </div>
    </section>
)
